'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerState = undefined;

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headerState = exports.headerState = function headerState(state) {
  var $siteHeader = $(_dom2.default.siteHeader);
  var $hoverOverlay = $(_dom2.default.hoverOverlay);

  if (state === 'active') {
    $siteHeader.addClass('is-active');
    $hoverOverlay.addClass('is-active');
  } else {
    $siteHeader.removeClass('is-active');
    $hoverOverlay.removeClass('is-active');
  }
};